export default {
  computed: {
    additionalRelatedAttributesFields() {
      return {
        kvp: [
          {
            label_en: 'I',
            label_pl: 'I',
            name: 'I',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'II',
            label_pl: 'II',
            name: 'II',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'III',
            label_pl: 'III',
            name: 'III',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'IIIa',
            label_pl: 'IIIa',
            name: 'IIIa',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'IIIb',
            label_pl: 'IIIb',
            name: 'IIIb',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'IV',
            label_pl: 'IV',
            name: 'IV',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'IVa',
            label_pl: 'IVa',
            name: 'IVa',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'IVb',
            label_pl: 'IVb',
            name: 'IVb',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'V',
            label_pl: 'V',
            name: 'V',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'VI',
            label_pl: 'VI',
            name: 'VI',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'VIz',
            label_pl: 'VIz',
            name: 'VIz',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          }
        ],
        pum: [
          {
            label_en: 'Residental',
            label_pl: 'Mieszkaniowy',
            name: 'residental',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'Office',
            label_pl: 'Biurowy',
            name: 'office',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'Retail',
            label_pl: 'Detaliczny',
            name: 'retail',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
          {
            label_en: 'Industrial',
            label_pl: 'Przemysłowy',
            name: 'industrial',
            translate: false,
            subtype: 'decimal',
            type: 'number'
          },
        ],
        date_range: [
          {
            label_en: 'From',
            label_pl: 'Od',
            name: 'from',
            translate: false,
            subtype: 'integer',
            type: 'number'
          },
          {
            label_en: 'To',
            label_pl: 'Do',
            name: 'to',
            translate: false,
            subtype: 'integer',
            type: 'number'
          },
        ]
      };
    },
  }
};
